<template>
    <div class="">
        <div v-if="this.isLoading" class="d-flex justify-content-center mt-5 mb-1">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">{{ this.getTranslatedText('__loading__') }}</span>
            </div>
        </div>
        <template v-if="!!this.isPhoneVerified">
            <div class="d-flex justify-content-center my-2">
<!--                <h4>Your phone number has been successfully verified!</h4>-->
                <h4>{{ this.getTranslatedText('__verified_success__', 'components.smsverification') }}</h4>
            </div>
        </template>
        <template v-else>
            <div v-if="this.exitPhoneVerification" class="d-flex justify-content-center my-2">
<!--                <h4>You have reached the maximum number of attempts.</h4>-->
                <h4>{{ this.getTranslatedText('__max_attempts_reached__', 'components.smsverification') }}</h4>
            </div>
            <div v-else>
                <div v-if="this.errorMessage && this.errorMessage.length" class="row my-2">
                    <div class="col-md-12 text-center">
                        <h5 class="text-danger">{{ this.getTranslatedText(this.errorMessage, 'components.smsverification') }}</h5>
                    </div>
                </div>
                <div v-if="!this.requestedVerificationCode">
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <template v-if="!this.hideSubtitles">
                                <template v-if="this.app.product_name == 'car_loan'">
<!--                                    <small style="display: inline-block; margin-bottom:20px;">Your will receive a verification code by SMS, standard messaging or data rates may apply.</small>-->
                                    <small style="display: inline-block; margin-bottom:20px;">{{ this.getTranslatedText('__verification_code_sent__', 'components.smsverification') }}</small>
                                </template>
                                <template v-else>
<!--                                    <p>For security reasons new accounts must verify their phone numbers.</p>-->
                                    <p>{{ this.getTranslatedText('__new_accounts_must_verify__', 'components.smsverification') }}</p>
                                </template>
                            </template>
                        </div>
                        <div v-if="!this.reachedMaxAttempts" class="col-md-12 text-center mb-1">
                            <small class="text-muted">
                                <span v-if="this.isLastAttempt">
                                    {{ this.getTranslatedText('__last_attempt__', 'components.smsverification') }}
                                </span>
                            </small>
                        </div>
                        <div class="col-md-6 offset-md-3">
                            <input
                                class="form-control"
                                minlength="10"
                                maxlength="10"
                                :placeholder="this.getTranslatedText('__enter_phone__', 'components.smsverification')"
                                v-model="this.verificationPhoneNumber"
                                @input="this.inputPhoneNumber()"
                            />
                            <div v-show="this.validationMessage && this.validationMessage.length" class="text-danger"><ul class="text-danger mb-0 mt-2"><li><span v-text="this.getTranslatedText(this.validationMessage, 'components.smsverification')"></span></li></ul></div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-md-6 offset-md-3" style="text-align: center;">
                            <a @click="this.requestVerificationCode()" class="btn btn-lg w-100 btn-primary">{{ this.getTranslatedText( this.verificationCodeText, 'buttons') }}</a>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="row">
                        <div v-if="!this.reachedMaxAttempts" class="col-md-12 text-center mb-3">
                            <small class="text-muted">
<!--                                Sent SMS code to: <b>{{ this.verificationPhoneNumber }}</b>.-->
                                {{ this.getTranslatedText('__sent_sms_to__', 'components.smsverification') }}
                                <b>{{ this.verificationPhoneNumber }}</b>.
                                <a v-if="this.showResendCode && this.attemptsCount.code < this.maxAttemptsPerRequest.code" href="#" @click="this.editPhoneNumber()">
                                    {{ this.getTranslatedText('__edit_phone__', 'components.smsverification') }}</a><br>
                                <span v-if="this.showResendCode && this.isLastAttempt">
<!--                                    You have 1 attempt left.-->
                                    {{ this.getTranslatedText('__last_attempt__', 'components.smsverification') }}
                                </span>
                            </small>
                        </div>
                        <div class="col-md-8 offset-md-2">
                            <input
                                class="form-control"
                                minlength="4"
                                maxlength="6"
                                :placeholder="this.getTranslatedText('__enter_code__', 'components.smsverification')"
                                v-model="this.verificationCode"
                                @input="this.errorMessage=''"
                            />
                            <div v-show="this.validationMessage && this.validationMessage.length" class="text-danger"><ul class="text-danger mb-0 mt-2"><li><span v-text="this.getTranslatedText(this.validationMessage, 'components.smsverification')"></span></li></ul></div>
                        </div>
                        <div v-if="this.resendCodeAttempts < this.maxResendCodeAttempts && this.attemptsCount.code < this.maxAttemptsPerRequest.code" class="col-md-12 mt-3 text-center">
                            <small class="text-muted">
                                <div v-if="!this.canResendCode" class="">
<!--                                    Resend code in {{ this.nextAttemptTimer }} seconds.-->
                                    {{ this.getTranslatedText('__resend_code_in__', 'components.smsverification') }} {{ this.nextAttemptTimer }} {{ this.getTranslatedText('__seconds__', 'components.smsverification') }}.
                                </div>
                                <div v-else class="">
<!--                                    <a href="#" @click="this.resendCode()">Resend code</a>-->
                                    <a href="#" @click="this.resendCode()">{{ this.getTranslatedText('__resend_code__', 'components.smsverification') }}</a>
                                </div>
                            </small>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-md-6 offset-md-3" style="text-align: center;">
                            <a @click="this.getVerification()" class="btn btn-lg w-100 btn-primary">{{this.getTranslatedText('__verify_code__', 'components.smsverification')}}</a>
                        </div>
                    </div>
                </div>

                <div v-if="this.allowSkipVerification || this.showSkipVerification" class="row mt-3">
                    <div class="col-md-12 py-2 text-center">
                        <template v-if="this.app.product_name == 'car_loan'">
                            <div v-html="this.getTranslatedText('__skip_verification_car_loan__', 'components.smsverification')"></div>
                        </template>
                        <template v-else>
                            <div v-html="this.getTranslatedText('__skip_verification_account_creation__', 'components.smsverification')"></div>
                        </template>
                    </div>
                    <div class="col-md-4 offset-md-4" style="text-align: center;">
                        <a id="btnNext" class="btn btn-md w-100 btn-secondary" disabled="false" @click="this.$emit('goToNextStep')">
                            {{ this.getTranslatedText('__skip__', 'buttons') }}
                        </a>
                    </div>
                </div>

            </div>
        </template>
    </div>
</template>
<script>

import { inject } from 'vue';
import { canadianPhoneValidation } from "@/form/helpers/field-validations.js";

export default {
    name: "SmsVerification",
    emits: ["update:model-value", "input", "goToNextStep"],
    setup(props) {
        const { app, updateApplicationField, getTranslatedText } = inject('app'); // app is being provided in Application.vue
        return {
            app,
            updateApplicationField,
            getTranslatedText
        }
    },
    components: {
    },
    props: ["minlength","maxlength","type","placeholder","value","name","label","hideSubtitles"],
    data: () => {

        let isLoading = false;
        let allowSkipVerification = false;

        let requestedVerificationCode = false;
        let currentStep = 'code';
        let attemptsCount = {
            code: 0,
            verification: 0,
        };

        let maxAttemptsPerRequest = {
            code: 3,
            verification: 3,
        };

        let verificationCodeText = '__request_code__';
        let verificationPhoneNumber = '';
        let verificationCode = '';
        let resendCodeAttempts = 0;
        let maxResendCodeAttempts = 2;
        let showResendCode = false;
        let locationUrl = window.location.href.split('?')[0];

        let isPhoneVerified = false;
        let exitPhoneVerification = false;

        let errorMessage = '';
        let validationMessage = '';
        let sid = null;

        let nextAttemptTimer = 5;
        let nextAttemptTimerIntervalId = null;

        return {
            isLoading,
            requestedVerificationCode,
            verificationPhoneNumber,
            verificationCode,
            verificationCodeText,
            showResendCode,
            resendCodeAttempts,
            maxResendCodeAttempts,
            errorMessage,
            validationMessage,
            sid,
            isPhoneVerified,
            exitPhoneVerification,
            maxAttemptsPerRequest,
            attemptsCount,
            currentStep,
            allowSkipVerification,
            locationUrl,
            //timer
            nextAttemptTimer,
            nextAttemptTimerIntervalId
        };
    },
    mounted() {
        if(!this.app.forcePhoneVerification) {
            this.$emit('goToNextStep');
        }
        else {
            // this.allowSkipVerification = this.app.sms_skip && this.app.sms_skip == '1';
            this.verificationPhoneNumber = this.app.phone_number ? this.app.phone_number : '';
        }
    },
    beforeDestroy() {
        clearInterval(this.nextAttemptTimerIntervalId);
    },
    computed: {
        showSkipVerification() {
            if(!!this.app.forceSmsVerification) {
                return false;
            }
            let minAttemptsBeforeShowingSkip = 1;
            return this.currentStep == 'code' && this.attemptsCount.code >= minAttemptsBeforeShowingSkip ||
                this.currentStep == 'verification' && (this.attemptsCount.code >= minAttemptsBeforeShowingSkip || this.attemptsCount.verification >= minAttemptsBeforeShowingSkip);
        },
        reachedMaxAttempts() {
            if(this.currentStep == 'code') {
                return this.attemptsCount.code >= this.maxAttemptsPerRequest.code;
            }
            else if(this.currentStep == 'verification') {
                return this.attemptsCount.verification >= this.maxAttemptsPerRequest.verification;
            }
            return false;
        },
        canResendCode() {
            return this.nextAttemptTimer <= 0;
        },
        isLastAttempt() {
            return this.maxAttemptsPerRequest[this.currentStep] - this.attemptsCount[this.currentStep] == 1;
        },
    },
    methods: {
        nextStepAfterSeconds(seconds = 2) {
            if(!!this.app.forceSmsVerification && !this.isPhoneVerified) {
                window.location.href = '/thank-you';
                return;
            }
            if(!!this.app.forcePhoneVerification && !this.isPhoneVerified) {
                this.updateApplicationField('wants_to_create_account', "no");
                setTimeout(() => this.$emit('goToNextStep'), (seconds*1000));
            }
        },
        async requestVerificationCode() {

            this.errorMessage = '';
            this.validationMessage = '';

            if(!this.validateInput('phone')) {
                this.validationMessage = '__enter_valid_phone__';
                return;
            }

            this.checkAttemptsLimits();
            this.attemptsCount.code++;

            // API request
            let codeRequest = await this.smsVerificationRequest('code', {
                phone: this.verificationPhoneNumber,
                source: this.locationUrl
            });
            if( codeRequest && codeRequest.status == 'success' && codeRequest.sid && codeRequest.sid.length ) {
                this.requestedVerificationCode = true;
                this.currentStep = "verification";
                this.sid = codeRequest.sid;
                this.reinitializeTimer();
            }
            else {
                this.errorMessage = "__sms_code_could_not_send__";
                this.sid = null;
                this.checkAttemptsLimits();
                return;
            }

            this.showResendCode = true;
        },
        async getVerification() {

            this.errorMessage = '';
            this.validationMessage = '';

            if(!this.validateInput('code')) {
                this.validationMessage = '__enter_valid_code__';
                return;
            }

            this.checkAttemptsLimits();
            this.attemptsCount.verification++;

            this.requestedVerificationCode = true;
            this.currentStep = "verification";
            this.verificationCodeText = '__request_code__';

            // API request
            let verificationRequest = await this.smsVerificationRequest('verification', {
                sid: this.sid,
                code: this.verificationCode,
                source: this.locationUrl
            });
            if( verificationRequest && verificationRequest.status == 'success' ) {
                this.successfulPhoneVerification();
            }
            else {
                this.errorMessage = '__sms_code_is_incorrect__';
                this.checkAttemptsLimits();
                return;
            }
        },
        successfulPhoneVerification() {
            this.isPhoneVerified = true;
            this.updateApplicationField('verified_phone_number', this.verificationPhoneNumber);
            this.updateApplicationField('phone_number', this.verificationPhoneNumber);
            this.updateApplicationField('isPhoneVerified', true);
            setTimeout(() => {
                this.$emit('goToNextStep');
            }, 2500);
        },
        editPhoneNumber() {
            this.verificationCodeText = '__request_another_code__';
            this.requestedVerificationCode = false;
            this.currentStep = "code";
            this.verificationCode = '';
            this.showResendCode = false;
            this.errorMessage = '';
            this.verificationMessage = '';
        },
        resendCode() {
            this.resendCodeAttempts++;
            this.requestVerificationCode();
        },
        checkAttemptsLimits() {
            if(this.reachedMaxAttempts) {
                this.exitPhoneVerification = true;
                this.nextStepAfterSeconds(3);
            }
        },
        validateInput(type) {
            let isValid = false;
            switch (type) {
                case 'phone':
                    isValid = this.validatePhone();
                    break;
                case 'code':
                    if(this.verificationCode.length >= 4 && this.verificationCode.length <= 6) {
                        isValid = true;
                    }
                    break;
                default:
                    break;
            }
            return isValid;
        },
        async smsVerificationRequest(type, data) {
            this.isLoading = true;

            let requestEndpoints = {
                'code': '/portal/phone/code',
                'verification': '/portal/phone/verification',
            };

            let apiResponse = await
                axios.post(requestEndpoints[type] ?? requestEndpoints['code'], data)
                    .then(res => {
                        return res.data;
                    }).catch(err => {
                        // TODO -- email exception?
                        return false;
                    });

            // console.log('apiResponse', apiResponse);

            this.isLoading = false;
            return apiResponse;
        },
        reinitializeTimer(time = 60) {
            this.nextAttemptTimer = time;
            this.nextAttemptTimerIntervalId = setInterval(() => {
                this.nextAttemptTimer--;
                if(this.nextAttemptTimer <= 0) {
                    clearInterval(this.nextAttemptTimerIntervalId);
                }
            }, 1000);
        },
        validatePhone(finalValidation = true, phoneNumber = null) {

            if(!phoneNumber) {
                phoneNumber = this.verificationPhoneNumber;
            }

            return canadianPhoneValidation(phoneNumber, finalValidation);
        },
        inputPhoneNumber() {
            this.validationMessage='';
            if(!this.validatePhone(false)) {
                this.validationMessage = '__enter_valid_phone__';
            }
        },
    },
}
</script>


<style scoped>
</style>
